import type * as React from "react";
import { GalleryVerticalEnd } from "lucide-react";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  SidebarRail,
} from "@/shadcnComponents/ui/sidebar";
import { Link } from "react-router-dom";

const data = {
  navMain: [
    {
      title: "Users Accounts",
      url: "/developer/admin",
      isActive: false,
      items: [
        {
          title: "All Influencers",
          url: "/developer/admin",
          isActive: false,
        },
        {
          title: "All Brands",
          url: "/developer/admin/brands",
          isActive: false,
        },
      ],
    },
    {
      title: "Brand Collaboration",
      url: "/developer/admin",
      isActive: false,
      items: [
        {
          title: "All Deals",
          url: "/developer/admin/deals",
          isActive: false,
        },
        {
          title: "All Campaigns",
          url: "/developer/admin/allCampaigns",
          isActive: false,
        },
        {
          title: "Influencer Collab",
          url: "/developer/admin",
          isActive: false,
        },
      ],
    },
    {
      title: "Earning & Invoicing",
      url: "/developer/admin/collab-earning",
      isActive: true,
      items: [
        {
          title: "Earnings",
          url: "/developer/admin/collab-earning",
          isActive: false,
        },
        {
          title: "Brand Invoice",
          url: "/developer/admin/brand-invoice",
          isActive: true,
        },
        {
          title: "Creator Invoice",
          url: "/developer/admin/creator-invoice",
          isActive: false,
        },
      ],
    },
  ],
};

export function DeveloperSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <a href="#">
                <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                  <GalleryVerticalEnd className="size-4" />
                </div>
                <div className="flex flex-col gap-0.5 leading-none">
                  <span className="font-semibold">Dashboard</span>
                  <span className="">Admin Panel</span>
                </div>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            {data.navMain.map((item) => (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton asChild isActive={item.isActive}>
                  <Link to={item.url} className="font-medium">
                    {item.title}
                  </Link>
                </SidebarMenuButton>
                {item.items?.length ? (
                  <SidebarMenuSub>
                    {item.items.map((subItem) => (
                      <SidebarMenuSubItem key={subItem.title}>
                        <SidebarMenuSubButton
                          asChild
                          isActive={subItem.isActive}
                        >
                          <Link to={subItem.url}>{subItem.title}</Link>
                        </SidebarMenuSubButton>
                      </SidebarMenuSubItem>
                    ))}
                  </SidebarMenuSub>
                ) : null}
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
